import * as X from "@/ui";

import Illustration from "./assets/illustration.png";

export function ArticleHero(props: X.PageProps<{
  categories: Array<{ slug: string; title: string }>;
  currentCategorySlug: string | null;
}>) {
  const tr = X.useTranslator(props.locale);

  const getHref = (categorySlug: string): X.PageHref => {
    if (categorySlug === props.currentCategorySlug) {
      return "/blog/tag";
    }

    return {
      pathname: "/blog/tag/[categorySlug]",
      params: { categorySlug },
    };
  };

  return (
    <section className="w-full xl:max-w-content xl:mx-auto sm:px-6 xl:px-0 xl:pb-16 xl:-mt-[80px] mb-8 xl:mb-0">
      <div className="flex flex-col xl:flex-row gap-8 items-center xl:items-end justify-between">
        <div className="flex-1 w-full xl:w-[800px]">
          <h1 className={X.clsx(
            "text-[35px] xl:text-[64px] font-normal text-center xl:text-start",
            "[&_strong]:font-medium leading-tight xl:mb-10 max-w-[80%] xl:max-w-full mx-auto",
            "mx-mobile-margin xl:mx-0",
          )}>
            {tr({
              en: <>Get inspired. Go explore. <strong>Save more!</strong></>,
              fr: <>Inspirez-vous, partez, <strong>économisez{X.Nbsp}!</strong></>,
            })}
          </h1>
          <p className="mt-6 text-[16px] xl:text-[24px] text-center xl:text-start mb-2 xl:mb-0 mx-mobile-margin xl:mx-0">
            {tr({ en: "What inspires you?", fr: "Qu'est-ce qui vous inspire ?" })}
          </p>

          <div className={X.clsx(X.desktopOnly("flex"), "flex-wrap gap-2 mt-4")}>
            {props.categories.map(category => (
              <X.Button
                key={category.slug}
                primary={category.slug === props.currentCategorySlug}
                tertiary={category.slug !== props.currentCategorySlug}
                className="rounded-[20px] !text-[13px] !font-normal !py-[4px] !px-[12px] !h-[33px]"
                label={category.title}
                href={getHref(category.slug)}
              />
            ))}
          </div>

          <div className={X.clsx(X.mobileOnly(), "overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none]")}>
            <div className="flex flex-row gap-4 px-mobile-margin py-4">
              {props.categories.map(category => (
                <X.Button
                  key={category.slug}
                  primary={category.slug === props.currentCategorySlug}
                  tertiary={category.slug !== props.currentCategorySlug}
                  className="rounded-[20px] !text-[13px] !font-normal !py-[4px] !px-[12px] !h-[33px] whitespace-nowrap"
                  label={category.title}
                  href={getHref(category.slug)}
                />
              ))}
              <div>
                <div className="w-4 h-[33px]" />
              </div>
            </div>
          </div>
        </div>

        <div className="relative xl:w-[540px] xl:h-[380px] rounded-lg overflow-hidden hidden xl:block">
          <X.Image
            src={Illustration}
            alt="Evasion"
            fill
            className="object-cover"
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
          />
        </div>
      </div>
    </section>
  );
}
